import { FrameContext } from './frame-canvas';

interface Sized {
  naturalWidth?: number;
  naturalHeight?: number;
  videoWidth?: number;
  videoHeight?: number;
  displayWidth?: number;
  displayHeight?: number;
  width?: unknown;
  height?: unknown;
}

/** Pixel size of a picture; `null` when it has none to read (an SVG element, a stub). */
export function sourceSize(source: CanvasImageSource): { width: number; height: number } | null {
  const s = source as Sized;
  const width = s.naturalWidth || s.videoWidth || s.displayWidth || (typeof s.width === 'number' ? s.width : 0);
  const height = s.naturalHeight || s.videoHeight || s.displayHeight || (typeof s.height === 'number' ? s.height : 0);
  return width > 0 && height > 0 ? { width, height } : null;
}

export interface DrawFittedOptions {
  /** Zoom around the centre, 1 = fitted. */
  scale?: number;
  /** Horizontal shift in output pixels. */
  offsetX?: number;
}

/**
 * Draws the picture fitted inside the frame, proportions kept and centred: a 1080×1350 post template on a 16:9
 * review gets black bars, not a stretch. A picture of unknown size fills the frame.
 */
export function drawFitted(
  ctx: FrameContext,
  source: CanvasImageSource,
  width: number,
  height: number,
  { scale = 1, offsetX = 0 }: DrawFittedOptions = {},
): void {
  const size = sourceSize(source);
  const fit = size ? Math.min(width / size.width, height / size.height) : 1;
  const w = (size ? size.width * fit : width) * scale;
  const h = (size ? size.height * fit : height) * scale;
  ctx.drawImage(source, (width - w) / 2 + offsetX, (height - h) / 2, w, h);
}
